import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener('click', this.handleModalShow.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleModalShow.bind(this))
  }

  handleModalShow(event) {
    if (event.target.matches('.js-modal-action-show[data-modal-id="gamification-widget"]')) {
      if (!this.contentLoaded) {
        this.loadContent()
        this.contentLoaded = true
      }
    }
  }

  loadContent() {
    const frame = document.createElement('turbo-frame')
    frame.id = 'gamification-widget'
    frame.src = '/gamification_widget'
    
    this.element.innerHTML = ''
    this.element.appendChild(frame)
  }

  closeModal(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const modal = this.element.closest('.c-modal-action')
    if (modal) {
      modal.style.display = 'none'
      this.contentLoaded = false
      this.element.innerHTML = ''
    }
  }
} 